import toast from 'react-hot-toast';

import { getAnalytics } from './../api'
import { useEffect, useState } from 'react'


export default function useGetAnalytics() {
  const [analytics, setAnalytics] = useState([])
  const [loading, setLoading] = useState(false)

  async function fetchAnalytics() {
    setLoading(true)
    try {
      const res = await getAnalytics()
      setAnalytics(res)

    } catch (err) {
      toast.error(err.message || 'Failed to fetch analytics')
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    fetchAnalytics()
  }, [])

  return { data: analytics, isLoading: loading }
}